import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateArticleDraft } from "../../../redux/slices/articles";
import * as images from "../../../utilities/images";
import CustomModal from "../../Modal/CustomModal";
import ScheduleModal from "../../Modal/ScheduleModal";
import PaymentDetail from "../paymentdetail";
import UnderreviewModal from "../../Modal/UnderreviewModal";
import { useStripe } from "@stripe/react-stripe-js";
import CardPaymentModal from "../../Modal/AddCardPaymentModal";
import { useConvertMarkDownHtml } from "../../../redux/customHooks/useConvertMarkDownHtml";
import Slider from "react-slick";

const DraftDetail = () => {
  const stripe = useStripe();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = location || location.state;
  console.log(state, "statedataa");

  const updatedraft = state?.selectedPublicationDetails;
  const getDraftInfo = state?.draftData;
  const draftInfo = state?.draftData;
  console.log(updatedraft?.multipleImages, "draftInfo");

  const htmlContent = useConvertMarkDownHtml(
    state?.type === "draft" ||
      state?.type === "schedule" ||
      state?.type === "rejected"
      ? updatedraft?.ckEditorContent
      : draftInfo?.description
  );
  console.log(htmlContent, "htmlContent123");

  const [time, setTime] = useState(
    getDraftInfo?.schedule?.time ? getDraftInfo?.schedule?.time : ""
  );

  const [date, setDate] = useState(
    getDraftInfo?.schedule?.date
      ? moment(getDraftInfo?.schedule?.date).format("yyyy-M-D")
      : ""
  );

  const [key, setKey] = useState(Math.random());
  const [articlescheduleInfo, setArticlescheduleInfo] = useState("");
  const [articlesTotalAmount, setArticlesTotalAmount] = useState("");
  const [modalDetail, setModalDetail] = useState({
    show: false,
    title: "",
    flag: "",
  });

  // const htmlContent = "<h2>The history of sports dates back to prehistoric times, with the earliest activities likely resembling today&rsquo;s running, wrestling, and swimming. Ancient civilizations like Egypt, Greece, and China had structured sports that reflected their culture and values. The Greeks, for example, introduced the Olympics in 776 BC, which showcased events such as boxing, wrestling, and chariot racing. These games were a celebration of physical prowess and were deeply intertwined with religious and social activities.</h2><p>In medieval Europe, sports like jousting and archery were prominent, largely driven by the warrior culture. Over time, these evolved into more organized forms of entertainment, giving birth to sports clubs and associations. By the 19th and 20th centuries, the industrial revolution and improved transportation allowed sports to become more organized and professional, leading to the global phenomena we witness today.</p><h3>The Physical and Mental Benefits of Sports</h3><p>The advantages of engaging in sports extend far beyond mere entertainment. Physical activities are vital for maintaining health and well-being, and organized sports offer structured ways to achieve fitness.</p><ol>	<li>	<p><strong>Physical Fitness</strong>: Regular participation in sports leads to improved cardiovascular health, muscle strength, flexibility, and endurance. Activities such as running, swimming, and cycling enhance lung function and blood flow, reducing the risk of chronic diseases.</p>	</li>	<li>	<p><strong>Mental Health</strong>: Physical exertion stimulates the release of endorphins, known as the &quot;feel-good&quot; hormones. This neurochemical response helps reduce stress, anxiety, and depression. Team sports also foster a sense of belonging and camaraderie, enhancing emotional well-being.</p>	</li>	<li>	<p><strong>Skill Development</strong>: Sports help cultivate essential life skills such as teamwork, leadership, time management, and discipline. These attributes are transferable to other areas of life, including education and professional careers.</p>	</li>	<li>	<p><strong>Enhanced Cognitive Function</strong>: Studies indicate that physical activity can boost brain function, improving memory, concentration, and problem-solving abilities. This is especially beneficial for children and teenagers, aiding their academic performance.</p>	</li>	<li>	<h3>The Physical and Mental Benefits of Sports</h3>	<p>The advantages of engaging in sports extend far beyond mere entertainment. Physical activities are vital for maintaining health and well-being, and organized sports offer structured ways to achieve fitness.</p>	</li></ol><h3>&nbsp;</h3>";

  //closeModal
  const handleOnCloseModal = () => {
    setModalDetail({
      show: false,
      title: "",
      flag: "",
    });
    setKey(Math.random());
  };

  // open modal
  const handleOpenModal = (flag) => {
    const modalFlag = flag?.flags || flag;
    setModalDetail({
      show: true,
      flag: modalFlag,
      type: modalFlag,
    });
    setKey(Math.random());
  };

  /**
   * to update to draf article status
   * @param {*} flag
   * @param {*} date
   * @param {*} time
   */

  const UpdateDraftArtile = (flags, dates, times, publicationDatas, cardId) => {
    let param = {
      cardId: cardId,
      userId: getDraftInfo?.userId,
      id: getDraftInfo?._id,
      creditImage: updatedraft?.creditImgUpload || undefined,
      url: updatedraft?.articleUrl,
      articleType: draftInfo?.articleType,
      articleBy: draftInfo?.articleBy || undefined,
      publicationId: publicationDatas,
      categoryName: updatedraft?.categorydata?.name,
      categoryId: updatedraft?.categorydata?._id,
      subCategoryName: updatedraft?.subCategoryData?.name,
      subCategoryId: updatedraft?.subCategoryData?._id,
      title: updatedraft?.title,
      description: updatedraft?.ckEditorContent || undefined,
      googleDriveUrl: updatedraft?.googleDriveUrl || undefined,
      multipleImages: updatedraft?.multipleImages || undefined,
      photos: updatedraft?.photo,
      saveAsDraft: flags,
      date: dates || undefined,
      time: moment(times)?.format("HH:mm") || undefined,
      addOn: "0",
    };

    dispatch(
      updateArticleDraft({
        ...param,
        async cb(res) {
          if (res.status) {
            if (res?.data?.data?.status === "under_review") {
              handleOpenModal("underreviewModal");
            } else if (res?.data?.data?.status === "schedule") {
              navigate("/drafts", { state: { flag: "schedule" } });
            } else if (res?.data?.data?.status === "draft") {
              navigate("/drafts");
            }
            // if (
            //   res?.data?.data?.clientSecret?.client_secret &&
            //   res?.data?.data?.clientSecret?.status == "requires_confirmation"
            // ) {
            //   try {
            //     const paymentResult = await stripe.confirmCardPayment(
            //       res?.data?.data?.clientSecret?.client_secret
            //     );
            //     if (paymentResult.error) {
            //       toast.error("Payment confirmation error");
            //       return;
            //     } else {
            //       toast.success("Article payment successfully");
            //     }
            //   } catch (error) {
            //     console.error("Payment error:", error);
            //   }
            // }
          }
        },
      })
    );
  };

  const paymentToken = (cardInfo) => {
    const { flag, date, time, publicationData } = articlescheduleInfo;
    UpdateDraftArtile(flag, date, time, publicationData, cardInfo?.cardId);
  };

  const updateDraftStatus = (flag, time, date) => {
    const publicationData = updatedraft?.publicationIds.map((data) => data._id);
    setArticlescheduleInfo({ flag, date, time, publicationData });
    const sumPublicationAmounts = updatedraft?.publicationIds?.reduce(
      (sum, item) => {
        const publicationAmount = item.publicationAmount
          ? parseInt(item.publicationAmount)
          : 0;
        const amount = item.amount || 0;
        return sum + publicationAmount + amount;
      },
      0
    );
    setArticlesTotalAmount(sumPublicationAmounts);
    if (sumPublicationAmounts > 0 && flag != "1" && state?.type != "schedule") {
      handleOpenModal("cardPaymentModal");
    } else {
      UpdateDraftArtile(flag, date, time, publicationData);
    }
  };

  // Function to convert date string to mm/dd/yyyy format
  const formatDate = (dateStr) => {
    const parts = dateStr.split("-");
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);

    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    return `${formattedMonth}/${formattedDay}/${year}`;
  };

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <i
          className="fas fa-arrow-right"
          style={{
            fontSize: "15px",
            color: "#FFF",
            padding: "10px",
            backgroundColor: "#ff5c5d",
            borderRadius: "50%",
            marginRight: "10px 11px",
         
          }}
        ></i>
      </div>
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <i
          className="fas fa-arrow-left"
          style={{
            fontSize: "15px",
            color: "#FFF",
            padding: "10px",
            backgroundColor: "#ff5c5d",
            borderRadius: "50%",
            marginLeft: "10px 11px",
         
          }}
        ></i>
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SamplePrevArrow />,
    prevArrow: <SampleNextArrow />,
   
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="content-wrapper dashboardSection pt-0">
        <div className="dashArticle">
          <div className="articleDetail_Fixed">
            <div className="innerHead justify-content-between">
              <div className="innerHeadleft">
                <img
                  src={images.arrowLink}
                  className="img-fluid pointCursor"
                  alt="arrowLink image"
                  onClick={() => {
                    {
                      state?.type === "rejected"
                        ? navigate("/articles"):
                        state?.type === "view"
                         ? navigate(-1)
                        : navigate("/write-article", {
                            state: state,
                          });

                    }
                  }}
                />
                <h2 className="innerHeadText">
                  {state?.type === "draft" ||
                  state?.type === "schedule" ||
                  state?.type === "rejected"
                    ? updatedraft?.title
                    : draftInfo?.title}
                </h2>
              </div>
              <h4 className="categoryText fw-400">
                {moment(draftInfo?.createdAt).format("MM/DD/YYYY")}
              </h4>
            </div>
            {draftInfo?.schedule?.date && draftInfo?.schedule?.time ? (
              <>
                <div className="articleSubcategory_ mt-3 ">
                  <h4 className="categoryText fw-400">
                    Schedule Date-{" "}
                    <strong className="textWhite fw-500">
                      {formatDate(draftInfo?.schedule?.date)}
                    </strong>
                  </h4>
                  <h4 className="categoryText fw-400">
                    Schedule Time-{" "}
                    <strong className="textWhite fw-500">
                      {draftInfo?.schedule?.time}
                    </strong>
                  </h4>
                </div>
              </>
            ) : (
              ""
            )}
            {draftInfo?.articleType === "ai" && (
              <div className="articleSubcategory_ mt-3 articles_SubCategory">
                <h4 className="categoryText fw-400">
                  Article Genre:{" "}
                  <strong className="textWhite fw-500">
                    {" "}
                    {state?.type === "draft" ||
                    state?.type === "schedule" ||
                    state?.type === "rejected"
                      ? updatedraft?.categorydata?.name
                      : draftInfo?.categoryName}
                  </strong>
                </h4>
              </div>
            )}

            <div className="articlePublication_ mt-3 article_Publication_Resp">
              <h5 className="heading_22">Publication:</h5>
              <div className="publicationMedia_ publication_Media_Resp">
                {state?.type === "draft" ||
                state?.type === "schedule" ||
                state?.type === "rejected" ||
                state?.type === "skip"
                  ? updatedraft?.publicationIds?.map((val, idx) => (
                      <div className="mediaInner_" key={idx}>
                        <img
                          src={val?.publicationLogo}
                          className="img-fluid me-2"
                          alt="media_image"
                        />
                        <span className="form_subheading">{val?.value}</span>
                      </div>
                    ))
                  : draftInfo?.publications?.map((val, idx) => (
                      <div className="mediaInner_" key={idx}>
                        <img
                          src={val?.publicationLogo}
                          className="img-fluid me-2"
                          alt="media_image"
                        />
                        <span className="form_subheading">
                          {val?.publicationName}
                        </span>
                      </div>
                    ))}
              </div>
            </div>
            {(updatedraft?.articleUrl || draftInfo?.url) && (
              <div className="articlePublication_ article_Publication_Resp mt-3">
                <h5 className="heading_22">Url:</h5>
                <div className="mediaInner_ d-flex align-items-center">
                  {/* <Link target="_blank" > */}
                  <a
                    href={updatedraft?.articleUrl || draftInfo?.url}
                    target="_blank"
                    className="form_subheading"
                  >
                    {updatedraft?.articleUrl || draftInfo?.url}
                  </a>
                  {/* </Link> */}
                </div>
              </div>
            )}
          </div>
          <div className="articleImage mt-4">
            <img
              src={
                state?.type === "draft" ||
                state?.type === "schedule" ||
                state?.type === "rejected"
                  ? updatedraft?.bannerImgUpload
                  : draftInfo?.photos
              }
              className="img-fluid me-2 previewImage"
              alt="media_image"
            />

            <p className="form_subheading text-center mt-2">
              {state?.type === "view"
                ? draftInfo?.creditImage
                : updatedraft?.creditImgUpload}
            </p>
          </div>

          <div className="contentPreviewDraftDetail mt-3 update_Draft_Btn">
            <div className="ckView row">
              <div
                dangerouslySetInnerHTML={{
                  __html: htmlContent,
                }}
              />
            </div>

            {(state?.type === "view"
              ? draftInfo?.creditImage
              : updatedraft?.creditImgUpload) && <></>}

            {/* <div className="row">
              {(updatedraft?.multipleImages?.length > 0 ||
                draftInfo?.multipleImages?.length > 0) &&
                (updatedraft?.multipleImages?.length > 0
                  ? updatedraft.multipleImages
                  : draftInfo?.multipleImages
                )?.map((item) => (
                  <div className="col-md-4">
                    <div className="mt-3">
                      <img
                        src={item}
                        className="img-fluid articleCover_Img"
                        alt="media_image"
                      />
                    </div>
                  </div>
                ))}
            </div> */}

            <div className="row mt-4 articleSlider_Row">
              <div className="slider-container articleMultiImg_Slider">
                {updatedraft?.multipleImages?.length > 1 ||
                draftInfo?.multipleImages?.length > 1 ? (
                  <Slider {...settings}>
                    {(updatedraft?.multipleImages?.length > 1
                      ? updatedraft.multipleImages
                      : draftInfo?.multipleImages
                    )?.map((item, index) => (
                      <div className="p-2">
                        <a
                          key={index}
                          // href={logo?.link}
                          className="marquee_Links"
                          target="_blank"
                        >
                          <div className="client_Logoes">
                            <img
                              src={item}
                              alt="slider_img"
                              className="img-fluid w-100 h-100 "
                            />
                          </div>
                        </a>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <>
                    {(updatedraft?.multipleImages?.length > 0
                      ? updatedraft.multipleImages
                      : draftInfo?.multipleImages
                    )?.map((item) => (
                      <div className="col-md-4">
                        <div className="mt-3">
                          <img
                            src={item}
                            className="img-fluid articleCover_Img"
                            alt="media_image"
                          />
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>

            {(updatedraft?.googleDriveUrl || draftInfo?.googleDriveUrl) && (
              <div className="articlePublication_ article_Publication_Resp mt-3">
                <h5 className="heading_22">Google Drive Url :-</h5>
                <div className="mediaInner_ d-flex align-items-center">
                  <a
                    className="form_subheading"
                    href={
                      updatedraft?.googleDriveUrl || draftInfo?.googleDriveUrl
                    }
                    target="_blank"
                  >
                    {updatedraft?.googleDriveUrl || draftInfo?.googleDriveUrl}
                  </a>
                </div>
              </div>
            )}

            {/* {(draftInfo?.addOns?.addOns) || (draftInfo?.addOns?.professional) && (
                  <>
                    <div className="addOnDetailSec">
                      <div className="offerDetailSec mt-5">
                        <h4 className="stateText">Offer Details</h4>
                        <div className="offerDetailBox mt-2">
                          <div className="offerUpper">
                            <h6 className="ratingText">Item</h6>
                            <h6 className="ratingText">Price</h6>
                          </div>
                          <div className="offerLower">
                            <h6 className="ratingText">{draftInfo?.title}</h6>
                            <h6 className="ratingText">
                              ${draftInfo?.totalAmount || "0"}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="addOnDetailSec mt-5">
                      <div className="offerDetailSec mt-2">
                        <h4 className="stateText">Add-on Details</h4>
                        {draftInfo?.addOns?.professional ||
                        draftInfo?.addOns?.interviewer ? (
                          <div className="offerDetailBox mt-2">
                            <div className="offerUpper">
                              <h6 className="ratingText">Item</h6>
                              <h6 className="ratingText">Price</h6>
                            </div>
                            {draftInfo?.addOns?.professional && (
                              <div className="offerLower">
                                <h6 className="ratingText">Professional</h6>
                                <h6 className="ratingText">
                                  ${draftInfo?.addOns?.professionalAmout}
                                </h6>
                              </div>
                            )}

                            {draftInfo?.addOns?.interviewer && (
                              <div className="offerLower">
                                <h6 className="ratingText">Interviewer</h6>
                                <h6 className="ratingText">
                                  ${draftInfo?.addOns?.interviewerAmount}
                                </h6>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="totalBox">
                          <h6 className="ratingText">Add On Total</h6>
                          <h6 className="ratingText">
                            ${draftInfo?.addOns?.totalAmount || 0}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="totalBox">
                      <h6 className="ratingText">Total Payment</h6>
                      <h6 className="ratingText">
                        $
                        {(draftInfo?.totalAmount || 0) +
                          (draftInfo?.addOns?.totalAmount || 0)}
                      </h6>
                    </div>
                  </>
                )} */}

            {state?.type === "draft" || state?.type === "rejected" ? (
              <>
                {/* <button
                  className="signUpBtn  mt-5 me-3"
                  type="button"
                  onClick={() => {
                    navigate("/draftDetail", {
                      state: {
                        ...state,
                        type: "skip",
                      },
                    });
                  }}
                >
                  Skip
                </button> */}
                <button
                  className="signUpBtn  mt-5 me-3"
                  type="button"
                  onClick={() => {
                    {
                      state?.type === "rejected"
                        ? navigate("/articles")
                        : navigate("/write-article", {
                            state: state,
                          });
                    }
                  }}
                >
                  Back
                </button>

                <button
                  className="signUpBtn  mt-5 me-3"
                  type="button"
                  onClick={() => {
                    navigate("/addOn-Article", {
                      state: {
                        ...state,
                        userInfo: state?.draftData,
                        selectedPublication: state?.selectedPublicationDetails,
                        type: state?.type,
                        htmlContent,
                      },
                    });
                  }}
                >
                  Next
                </button>
              </>
            ) : state?.type === "schedule" ? (
              <>
                <button
                  className="blockbtn  me-3 mt-5"
                  onClick={() => {
                    updateDraftStatus("0");
                  }}
                >
                  Submit
                </button>
                <button
                  className="secondaryBtb_  me-3 mt-5"
                  onClick={() => {
                    handleOpenModal("scheduleModal");
                  }}
                >
                  Schedule
                </button>
              </>
            ) : state?.type === "skip" ? (
              <>
                <button
                  className="blockbtn  me-3 mt-5"
                  onClick={() => {
                    updateDraftStatus("0");
                  }}
                >
                  Submit
                </button>
                {draftInfo?.schedule?.date && draftInfo?.schedule?.time ? (
                  ""
                ) : (
                  <button
                    className="blockbtn  me-3 mt-5"
                    onClick={() => {
                      updateDraftStatus("1");
                    }}
                  >
                    Draft
                  </button>
                )}
                <button
                  className="secondaryBtb_  me-3 mt-5"
                  onClick={() => {
                    handleOpenModal("scheduleModal");
                  }}
                >
                  Schedule
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
      <CustomModal
        key={key}
        show={modalDetail.show}
        backdrop="static"
        showCloseBtn={false}
        isRightSideModal={true}
        mediumWidth={false}
        ids={
          modalDetail.flag === "scheduleModal"
            ? "ScheduleModal"
            : modalDetail.flag === "underreviewModal"
            ? "underreviewModal"
            : modalDetail.flag === "cardPaymentModal"
            ? "cardPaymentModal"
            : "paymentModal"
        }
        child={
          modalDetail.flag === "scheduleModal" ? (
            <ScheduleModal
              createNewArticle={(flag, time, date) =>
                updateDraftStatus(flag, time, date)
              }
              timeValue={time}
              dateValue={date}
            />
          ) : modalDetail.flag === "underreviewModal" ? (
            <UnderreviewModal close={() => handleOnCloseModal()} />
          ) : modalDetail.flag === "paymentModal" ? (
            <PaymentDetail
              close={() => handleOnCloseModal()}
              paymentToken={paymentToken}
              paymentFlag={"articlePayment"}
              handleOpenModal={(data) => handleOpenModal(data)}
            />
          ) : modalDetail.flag === "cardPaymentModal" ? (
            <CardPaymentModal
              close={() => handleOnCloseModal()}
              paymentToken={paymentToken}
              paymentFlag={"articlePayment"}
              totalAmount={articlesTotalAmount}
              // selectedPlanData={selectedPlanData || ""}
              handleOpenModal={(data) => handleOpenModal(data)}
            />
          ) : (
            ""
          )
        }
        header={
          modalDetail.flag === "scheduleModal" ? (
            <>
              <h2 className="modal_Heading">Schedule For Later</h2>
              <p onClick={handleOnCloseModal} className="modal_cancel">
                <img src={images.modalCross} className="ModalCance" alt="" />
              </p>
            </>
          ) : modalDetail.flag === "paymentModal" ? (
            <>
              <h2 className="modal_Heading">Payment</h2>
              <p onClick={handleOnCloseModal} className="modal_cancel">
                <img src={images.modalCross} className="ModalCance" alt="" />
              </p>
            </>
          ) : modalDetail.flag === "cardPaymentModal" ? (
            <>
              <h2 className="modal_Heading">Payment</h2>
              <p onClick={handleOnCloseModal} className="modal_cancel">
                <img src={images.modalCross} className="ModalCance" alt="" />
              </p>
            </>
          ) : (
            ""
          )
        }
        onCloseModal={() => handleOnCloseModal()}
      />
    </>
  );
};

export default DraftDetail;
